import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import * as errorHandlerActions from '@/components/errorHandler/Actions';
import * as sharedActions from '@/shared/Actions';
import { getUpdateUserPath, ROUTES_API } from '@/services/Constants';
import { processRequest } from '@/services/Api';
import { historyPush } from '@/services/History';
import * as onboardingActions from '../store/actions';
import { onboardingActionTypes } from '../store/constants';
import { getUserId } from '../store/selectors';

import type { SagaIterator } from 'redux-saga';

export default function* (): SagaIterator {
	yield all([
		yield takeLatest(onboardingActionTypes.GET_GRADES_REQUEST, handleGetGradesRequest),
		yield takeLatest(onboardingActionTypes.SAVE_GRADE_REQUEST, handleSaveGradeRequest),
		yield takeLatest(onboardingActionTypes.SAVE_PASSWORD_REQUEST, handleSavePasswordRequest),
		yield takeLatest(onboardingActionTypes.SAVE_CHILD_NAME_REQUEST, handleSaveChildNameRequest),
		yield takeLatest(onboardingActionTypes.SET_REFERENCE_CHANNEL, handleSetReferenceChannel),
	]);
}

export function* handleGetGradesRequest(): SagaIterator {
	try {
		const { data } = yield call(processRequest, ROUTES_API.GRADES);

		yield put(onboardingActions.getGradesSuccess(data.grades));
	} catch (e) {
		yield put(onboardingActions.getGradesError());
		yield put(errorHandlerActions.handleError(e));
	}
}

export function* handleSaveGradeRequest({ payload }: any): SagaIterator {
	try {
		const userId = yield select(getUserId);
		const { data } = payload;
		const { grade } = data;

		yield call(processRequest, getUpdateUserPath(userId), 'PUT', {
			user: { grade_id: grade },
		});

		yield call(processRequest, getUpdateUserPath(userId), 'PUT', {
			user: { onboarding_completed: true },
		});

		yield put(sharedActions.getUserDataRequest());
		yield put(onboardingActions.saveGradeSuccess(null));
		yield call(historyPush, '/');
	} catch (e) {
		yield put(onboardingActions.saveGradeError());
		yield put(errorHandlerActions.handleError(e, 'notification'));
	}
}

export function* handleSavePasswordRequest({ payload }: any): SagaIterator {
	try {
		const { password, redirectPath } = payload;

		yield call(processRequest, ROUTES_API.SET_PASSWORD, 'PATCH', { password });
		yield call(historyPush, redirectPath);
		yield put(onboardingActions.savePasswordSuccess());
	} catch (e) {
		yield put(onboardingActions.savePasswordError());
		yield put(errorHandlerActions.handleError(e));
	}
}

export function* handleSaveChildNameRequest({ payload }: any): SagaIterator {
	try {
		const userId = yield select(getUserId);
		const { childName: child_name, redirectPath } = payload;

		yield call(processRequest, getUpdateUserPath(userId), 'PUT', { user: { child_name } });
		yield call(historyPush, redirectPath);
		yield put(onboardingActions.saveChildNameSuccess());
	} catch (e) {
		yield put(onboardingActions.saveChildNameError());
		yield put(errorHandlerActions.handleError(e));
	}
}

export function* handleSetReferenceChannel({ payload }: any): SagaIterator {
	try {
		const userId = yield select(getUserId);
		const { referenceChannel: reference_channel, redirectPath } = payload;

		yield call(processRequest, getUpdateUserPath(userId), 'PUT', {
			user: { account: { reference_channel } },
		});

		yield call(historyPush, redirectPath);
		yield put(onboardingActions.setReferenceChannelSuccess());
	} catch (e) {
		yield put(onboardingActions.setReferenceChannelError());
		yield put(errorHandlerActions.handleError(e));
	}
}
